module.exports = __webpack_public_path__ + "static/media/AdminNómina_FaltasExtras.e90391e0.svg";